import { render, staticRenderFns } from "./transaction-summary.vue?vue&type=template&id=66d834a6&scoped=true"
import script from "./transaction-summary.vue?vue&type=script&lang=js"
export * from "./transaction-summary.vue?vue&type=script&lang=js"
import style0 from "./transaction-summary.vue?vue&type=style&index=0&id=66d834a6&scoped=true&lang=css"
import style1 from "./transaction-summary.vue?vue&type=style&index=1&id=66d834a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d834a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d834a6')) {
      api.createRecord('66d834a6', component.options)
    } else {
      api.reload('66d834a6', component.options)
    }
    module.hot.accept("./transaction-summary.vue?vue&type=template&id=66d834a6&scoped=true", function () {
      api.rerender('66d834a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data-agent/transaction-summary.vue"
export default component.exports